type State = {
  load: boolean,
  message: string,
};

type Payload = {
  load: boolean,
  message?: string,
};

export default {
  state: {
    load: false,
    message: '',
  },
  reducers: {
    loading: (state: State, payload: Payload) => {
      return {
        ...state,
        load: payload.load,
        message: payload.message || '',
      };
    },
  },
};
